// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import '../../App.css';

import TypeOfProperty from './TypeOfProperty';
import AmountOfSpace from './AmountOfSpace';
import TrueOrFalse from './TrueOrFalse';
import TextField from './TextField';
import TextInput from './TextInput';
import Contact from './Contact';
import Adress from './Adress';
import Success from './Success';

import { Questions } from '../../assets/model';

import {
  setAnswer,
  setAnswerStayQuestion,
  nextQuestion,
  skipQuestion,
  sendRating
} from '../../redux/rating';

import Slider, { Range } from 'rc-slider';

import { CSSTransitionGroup } from 'react-transition-group';
import { log } from 'util';
import { logger } from 'handlebars';
import { Z_FILTERED } from 'zlib';

type Props = {
  state: any,
  setAnswer: () => void,
  setAnswerStayQuestion: () => void,
  nextQuestion: number => void,
  skipQuestion: () => void,
  sendRating: ({}) => void,
  dispatch: any
};

type State = {
  activeQuestion: number
};

export type answer = {
  path: string,
  payload: {
    answer: string,
    nextQuestion: number
  }
};

class QuestionHandler extends React.Component<Props, State> {
  _answer = (questionNo, answer: answer) => {
    const reduxAnswer = {
      path: answer.answerPath,
      payload: {
        answer: answer.value,
        nextQuestion: answer.nextQuestion
      }
    };
    this.props.setAnswer(reduxAnswer);
  };

  _setAnswerStayQuestion = (questionNo, answer: answer) => {
    const reduxAnswer = {
      path: answer.answerPath,
      payload: {
        answer: answer.value,
        nextQuestion: this.props.state.currentQuestion
      }
    };
    this.props.setAnswerStayQuestion(reduxAnswer);
  };

  _setAnswerUndefined = (questionNo, answer: answer) => {
    const reduxAnswer = {
      path: answer.answerPath,
      payload: {
        answer: undefined
      }
    };
    this.props.setAnswerStayQuestion(reduxAnswer);
  };

  _nextQuestion = nextQuestion => {
    this.props.nextQuestion(nextQuestion);
  };

  _ContactMounted = () => {
    let date = new Date()
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ');

    let answer = {
      path: 'timestamp',
      payload: {
        answer: date
      }
    };

    this.props.setAnswerStayQuestion(answer);
  };

  _submitForm = model => {
    console.log('submit form:');
    console.log(model);

    let url = new URL(window.location.href);
    let origin = url.searchParams.get('origin');

    fetch(`https://www.api.immobilien-knowhow.de/propertyrating/${origin}`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(model)
    })
      .then(res => {
        console.log(res);
        res.status === 201
          ? this.props.nextQuestion(27)
          : () => {
              alert('Fehler');
            };
      })
      .catch(error => {
        alert('Senden Fehlgeschlagen: ', error);
      });
  };

  render(): React.Node {
    const items = [
      // BOTH
      <TypeOfProperty onClick={this._answer} question={0} key={1} />,

      // HOUSE PATH
      <TypeOfProperty onClick={this._answer} question={1} key={2} />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={2}
        key={3}
      />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={3}
        key={4}
      />,
      <TypeOfProperty
        small={true}
        onClick={this._answer}
        question={4}
        key={5}
      />,
      <TrueOrFalse
        onClick={this._setAnswerStayQuestion}
        onSkip={this._setAnswerUndefined}
        onNext={this._nextQuestion}
        question={5}
        key={6}
      />,
      <TrueOrFalse
        onClick={this._setAnswerStayQuestion}
        onSkip={this._setAnswerUndefined}
        onNext={this._nextQuestion}
        question={6}
        key={7}
      />,
      <TextField
        onClick={this._setAnswerStayQuestion}
        onNext={() => {
          this._nextQuestion(8);
        }}
        question={7}
        key={8}
      />,
      <TypeOfProperty onClick={this._answer} question={8} key={9} />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={9}
        key={10}
      />,
      <TypeOfProperty onClick={this._answer} question={10} key={11} />,
      <TypeOfProperty onClick={this._answer} question={11} key={12} />,

      // FLAT PATH
      <TypeOfProperty onClick={this._answer} question={12} key={13} />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={13}
        key={14}
      />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={14}
        key={15}
      />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={15}
        key={16}
      />,
      <TypeOfProperty onClick={this._answer} question={16} key={17} />,
      <TrueOrFalse
        onClick={this._setAnswerStayQuestion}
        onSkip={this._setAnswerUndefined}
        onNext={this._nextQuestion}
        question={17}
        key={18}
      />,
      <TrueOrFalse
        onClick={this._setAnswerStayQuestion}
        onSkip={this._setAnswerUndefined}
        onNext={this._nextQuestion}
        question={18}
        key={19}
      />,
      <TextField
        onClick={this._setAnswerStayQuestion}
        onNext={() => {
          this._nextQuestion(20);
        }}
        question={19}
        key={20}
      />,
      <TypeOfProperty onClick={this._answer} question={20} key={21} />,
      <AmountOfSpace
        onChange={this._setAnswerStayQuestion}
        onNext={this._nextQuestion}
        question={21}
        key={22}
      />,
      <TypeOfProperty onClick={this._answer} question={22} key={23} />,
      <TypeOfProperty onClick={this._answer} question={23} key={24} />,

      // BOTH PATH
      // ZIP
      <TextInput
        onClick={this._setAnswerStayQuestion}
        onNext={() => {
          this._nextQuestion(26);
        }}
        question={24}
        key={25}
      />,
      <Adress
        onChange={this._setAnswerStayQuestion}
        onNext={() => {
          this._nextQuestion(26);
        }}
        question={25}
        key={26}
      />,
      <Contact
        onChange={this._setAnswerStayQuestion}
        onSubmit={() => {
          this._submitForm(this.props.state.Model);
        }}
        onComponentDidMount={this._ContactMounted}
        question={26}
        key={27}
      />,
      <Success key={28} />
    ];

    return (
      <React.Fragment>
        <div className="main">
          <CSSTransitionGroup
            transitionName="slideleft"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {items[this.props.state.currentQuestion]}
          </CSSTransitionGroup>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(state => ({ state }), {
  setAnswer,
  setAnswerStayQuestion,
  nextQuestion,
  skipQuestion,
  sendRating
})(QuestionHandler);



// WEBPACK FOOTER //
// ./src/components/questions/_QuestionHandler.js